import { render, staticRenderFns } from "./notice-drawer.vue?vue&type=template&id=1f4258ed&"
import script from "./notice-drawer.vue?vue&type=script&lang=js&"
export * from "./notice-drawer.vue?vue&type=script&lang=js&"
import style0 from "./notice-drawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports